import type { CommentTarget } from '../../data-contract/comment';

/**
 * The document identifies the task body the same way for both comment vocabularies: one
 * description section, and workflow steps named by position. Work-task targets carry the position
 * directly; profile-task targets carry the same name the transport adapter synthesizes.
 */
export const DESCRIPTION_DOCUMENT_SECTION_ID = 'description';

export const workflowStepDocumentId = (stepIndex: number): string => `step-${stepIndex}`;

const getTargetIdentity = (target: CommentTarget): string => {
    switch (target.kind) {
        case 'title':
            return 'title';
        case 'description-section':
            return `description-section:${target.sectionId}`;
        case 'skill':
            return `skill:${target.skillId}`;
        case 'workflow-step':
            return `workflow-step:${target.workflowStepId}`;
        case 'description':
            return `description-section:${DESCRIPTION_DOCUMENT_SECTION_ID}`;
        case 'workflow-step-title':
        case 'workflow-step-description':
            return `workflow-step:${workflowStepDocumentId(target.stepIndex)}`;
    }
};

export const createCommentsDocument = (targets: readonly CommentTarget[]) => {
    const identities = new Set<string>();

    for (const target of targets) {
        const identity = getTargetIdentity(target);
        if (identities.has(identity)) {
            throw new Error(`Duplicate comment target: ${identity}`);
        }
        identities.add(identity);
    }

    return { targets };
};
